import * as React from 'react';
import {
  MasonryEngineNode,
  type MasonryEngineNodeRendererProps,
} from '@leagueplatform/masonry-engine';
import {
  LargeSkeleton,
  SmallSkeleton,
  ExtraSmallSkeleton,
  HeroBannerSkeleton,
} from '@leagueplatform/masonry-widgets';

export interface MasonryLoaderNodeProps {
  type: 'extraSmall' | 'small' | 'large' | 'heroBanner';
}

export type MasonryLoaderNode = MasonryEngineNode<
  'loader',
  MasonryLoaderNodeProps
>;

export type MasonryLoaderRendererProps =
  MasonryEngineNodeRendererProps<MasonryLoaderNode>;

export const MasonryLoaderRenderer = ({
  type,
  locatorId,
  css,
  rootElementRef,
}: MasonryLoaderRendererProps) => {
  switch (type) {
    case 'extraSmall':
      return (
        <ExtraSmallSkeleton
          data-testid={locatorId}
          css={css}
          ref={rootElementRef}
        />
      );
    case 'small':
      return (
        <SmallSkeleton data-testid={locatorId} css={css} ref={rootElementRef} />
      );
    case 'large':
      return (
        <LargeSkeleton data-testid={locatorId} css={css} ref={rootElementRef} />
      );
    case 'heroBanner':
      return (
        <HeroBannerSkeleton
          data-testid={locatorId}
          css={css}
          ref={rootElementRef}
        />
      );
    default:
      return null;
  }
};
